module.exports = {
    "message.outboundView.table.planQuantity": "Kế hoạch Số Lượng",
    "message.taskCenterView.button.reset": "Thiết lập lại",
    "message.views.inventoryAging.fulfillmentSkuName": "Thực hiện Mã Hàng Tên",
    "message.views.inventoryReconciliation.changeTypeMap.totalOtherInboundedStock": "Khác Inbounded",
    "message.views.productPublishView.plsSelectTheCategory": "Xin vui lòng chọn các loại",
    "message.outboundView.button.reset": "Thiết lập lại",
    "message.button.export": "Xuất khẩu",
    "message.menu.inboundItemName": "Gửi đến",
    "message.views.dashboardScore.dashboardName.channel_product_sold": "Kênh Sản Phẩm Được Bán",
    "message.views.activityInventory.occupyQuantity": "Chiếm Số Lượng",
    "message.views.workbench.warehouse": "Kho",
    "message.outboundView.table.inventoryType": "Loại hàng tồn kho",
    "message.lzdInboundCreateView.tableColumn.sellerDetail": "Người bán Chi Tiết",
    "message.views.scItemView.skuStatus": "MÃ HÀNG Tình Trạng",
    "message.transform.shopBind": "Cửa hàng RÀNG BUỘC",
    "message.views.dashboardScore.dashboardName.to_deliver": "Để Cung Cấp",
    "message.inboundView.table.platform": "Nền Tảng",
    "message.transform.cancel": "Hủy bỏ",
    "message.transform.startInventoryBind": "Bắt đầu Hàng Tồn Kho RÀNG BUỘC",
    "message.common.select": "Chọn xin vui lòng",
    "message.views.liveInventory.warehouseName": "Kho Tên",
    "message.views.productPublishView.mainImage": "Chính hình ảnh",
    "message.views.inventoryAging.31-60day": "31-60 ngày",
    "message.aegInboundDetail.title.creator": "Đấng tạo hóa",
    "message.card.fulfillment.warehouseName": "Kho Tên",
    "message.menu.inboundPlanItemDetail": "Thông tin chi tiết của bổ sung kế hoạch",
    "message.inboundView.alert.shop": "Cửa hàng Được Lựa Chọn",
    "message.lzdInboundCreateView.tableColumn.contactPerson": "Liên hệ với Tên",
    "message.common.commit": "Cam kết",
    "message.views.workbench.activityResult": "Hoạt động Kết Quả",
    "message.views.activityInventory.scItemId": "ScItemId",
    "message.views.liveInventory.unSellable": "Unsellable",
    "message.transform.shopBindSuccess": "Cửa hàng Ràng Buộc Thành Công",
    "message.lzdInboundCreateView.tableColumn.deliverType": "Cung cấp Loại",
    "message.views.liveInventory.name": "Tên",
    "message.views.feedback.feedbackOptions.productSuggestion": "Đề Nghị sản phẩm",
    "message.transform.lzd.description": "Lazada Cửa Hàng Ràng Buộc Lối Vào",
    "message.button.cancel": "Hủy bỏ",
    "message.inboundView.button.template": "Mẫu",
    "message.lzdOutboundViewDetail.title.orderStatus": "Tình Trạng đặt hàng",
    "message.views.productPublishView.plsSelectThePublishShop": "Xin vui lòng chọn các xuất bản cửa hàng",
    "message.lzdOutboundViewDetail.title.outboundOrderCode": "Outbound Không Có",
    "message.views.inventoryLedger.orderTypeMap.OUTBOUND": "Người bán/Nhà Cung Cấp Outbound",
    "message.inboundView.table.planQuantity": "Kế hoạch Số Lượng",
    "message.card.fulfillment.fulfillmentOrderId": "Thực hiện ID Đặt Hàng",
    "message.table.fulfillment.itemShippingActualPaidFee": "Vận Chuyển hàng Thực Tế Thanh Toán Phí",
    "message.views.scItemView.skuId": "MÃ HÀNG ID",
    "message.transform.startShopBindCheck": "Bắt đầu Cửa Hàng Ràng Buộc Kiểm Tra",
    "message.table.fulfillment.receiverName": "Tên người nhận",
    "message.aegOutboundOrderDetail.purchaseItemColumn.barcode": "BareCode",
    "message.table.fulfillment.itemQuantity": "Hàng Số Lượng",
    "message.views.dashboardScore.dashboardName.to_inbound": "Để Gửi Đến",
    "message.login.task_center": "Nhiệm vụ trung tâm",
    "message.lzdOutboundViewDetail.title.ioTypeName": "IO Loại",
    "message.lzdInboundPlanView.replenishColumns.replQuantity": "REPL Số Lượng",
    "message.views.workbench.shopItemSoldData": "Tỷ lệ Của Mặt Hàng Bán",
    "message.aegInboundDetail.purchaseItemColumn.receivedNormalQty": "Nhận được Bình Thường Số Lượng",
    "message.aegOutboundOrderDetail.title.creator": "Đấng tạo hóa",
    "message.transform.stockBindStore": "Cổ Ràng Buộc Cửa Hàng",
    "message.views.inventoryLedger.orderTypeMap.CHECK_IN": "Chu kỳ Đếm Tăng",
    "message.table.fulfillment.fulfillmentOrderItemId": "Thực hiện Mục Đặt Hàng ID",
    "message.menu.fulfillmentPackage": "Thực hiện Gói",
    "message.table.fulfillment.merchantCode": "Thương gia",
    "message.aegOutboundOrderDetail.logisticColumns.fulfillStatusDesc": "Thực hiện Tình Trạng Quyết Định",
    "message.views.stockAllocation.edit": "Chỉnh sửa",
    "message.menu.taskCenterItem": "Trung Tâm tải về",
    "message.button.setting": "Thiết lập",
    "message.common.fulfillment.deliveryConfirm": "Giao hàng xác nhận",
    "message.views.productView.fulfillmentSku": "FulfillmentSku",
    "message.taskCenterView.button.search": "Tìm kiếm",
    "message.taskCenterView.table.operate": "Hoạt động",
    "message.views.publishTemplateView.deleteTemplate": "Xóa Mẫu",
    "message.views.stockAllocation.ruleAllocation": "Điều chỉnh Quy Tắc",
    "message.menu.inOutBound": "InBound Và Outbound",
    "message.login.switch_to_zh_cn": "切换为中文",
    "message.lzdInboundCreateView.addSkuView.barcodes": "Mã vạch",
    "message.transform.mentionInfo": "Hàng tồn kho ràng buộc là dự kiến sẽ mất một vài phút. Làm không đóng trang hiện tại",
    "message.menu.stockAllocation": "Kênh Quản Lý Hàng Tồn Kho",
    "message.views.liveInventory.shipper": "Người gửi hàng",
    "message.transform.downStep": "Bước tiếp theo",
    "message.aegOutboundOrderDetail.title.totalQtyDec": "Số lượng",
    "message.table.fulfillment.itemId": "Item ID",
    "message.lzdInboundCreateView.tableColumn.sellerPostcode": "Mã Bưu điện",
    "message.CreateTransferOrder.receiverName": "Tên người nhận",
    "message.views.scItemView.sureDelete": "Hãy chắc chắn để xóa?",
    "message.lzdInboundDetail.title.sellerName": "Người Bán Tên",
    "message.CreateTransferOrder.deliverType": "Giao hàng Loại",
    "message.views.workbench.inboundOrderNo": "Gửi đến Thứ Tự Mã",
    "message.views.feedback.systemRate": "Hệ thống Tỷ Lệ",
    "message.menu.createNewInboundOrder": "Tạo ra Gửi Đến Thứ Tự",
    "message.taskCenterView.title.createdTime": "Tạo ra Thời Gian",
    "message.aegInboundDetail.logisticColumn.fulfillStatus": "Thực hiện Tình Trạng",
    "message.views.liveInventory.sellableOccupy": "Dành riêng Sellable",
    "message.views.productView.brand": "Thương hiệu",
    "message.aegInboundDetail.title.orderStatus": "Tình Trạng đặt hàng",
    "message.transform.shopBindingWaitingMention": "Cửa hàng ràng buộc là dự kiến sẽ mất một vài phút, xin vui lòng không đóng trang hiện tại.",
    "message.button.print": "In",
    "message.views.publishTemplateView.gmtModified": "Thay đổi Thời Gian",
    "message.views.stockAllocation.adjustStockFailed": "Điều chỉnh Cổ Thất Bại",
    "message.views.inventoryLedger.inventoryTypeMap.onWay": "TRÊN CÁCH",
    "message.table.fulfillment.itemActualPaidFee": "Mục Thực Tế Thanh Toán Phí",
    "message.aegOutboundOrderDetail.logisticColumns.fulfillStatus": "Thực hiện Tình Trạng",
    "message.outboundView.title.platform": "Nền Tảng",
    "message.menu.activityInventory": "Hoạt động Hàng Tồn Kho",
    "message.views.workbench.yoy": "SO VỚI CÙNG KỲ",
    "message.inboundView.alert.title": "Bạn có chắc chắn để hủy bỏ?",
    "message.transform.errorFile": "Lỗi Tập Tin",
    "message.views.productPublishView.clickDownloadPublishTemplate": "Tải về các Xuất Bản Mẫu",
    "message.views.scItemView.fulfillmentTitle": "FulfillmentSku Tiêu Đề",
    "message.transform.boundShop": "Ràng buộc Cửa Hàng",
    "message.CreateTransferOrder.senderPostCode": "Tên người gửi Mã Bưu Điện",
    "message.views.activityInventory.site": "Trang web",
    "message.card.fulfillment.receiverMobile": "Receiver Di Động",
    "message.menu.gfc.enter": "Nhập GFC",
    "message.inboundView.table.createTime": "Tạo ra Thời Gian",
    "message.inboundView.table.merchantName": "Thương gia Tên",
    "message.menu.shipConfirm": "Con tàu Xác Nhận",
    "message.views.scItemView.sureBind": "Hãy chắc chắn để ràng buộc?",
    "message.button.orderExport": "Để xuất khẩu",
    "message.transform.failDetail": "Xin vui lòng xem thông tin chi tiết về sự thất bại",
    "message.menu.scItemView": "Hàng hóa",
    "message.views.productView.mainShop": "Chính Cửa Hàng",
    "message.lzdInboundDetail.lzdItemTable.sellerSku": "Người Bán Mã Hàng",
    "message.views.workbench.productSoldTendency": "Sản phẩm Được Bán Xu Hướng",
    "message.table.fulfillment.orderItemStatus": "Mục đặt hàng Tình Trạng Mã",
    "message.views.workbench.dailyOrderQuantity": "Hàng ngày Số Lượng Đặt Hàng",
    "message.views.workbench.shopName": "Cửa hàng Tên",
    "message.form.fulfillment.inputShippingName": "Xin vui lòng nhập vào vận chuyển Tên!",
    "message.views.inventoryAging.platform": "Nền Tảng",
    "message.outboundView.title.warehouseList": "Kho",
    "message.lzdOutboundViewDetail.title.warehouseName": "Kho",
    "message.views.activityInventory.platformSkuName": "Nền tảng Mã Hàng Tên",
    "message.lzdOutboundViewDetail.title.mobile": "Điện thoại di động",
    "message.CreateTransferOrder.estimatedInboundTime": "Ước tính gửi đến thời gian",
    "message.views.inventoryLedger.orderTypeMap.COORDINATE_IN": "Kho Chuyển Gửi Đến",
    "message.views.scItemView.category": "Category",
    "message.views.workbench.thisWeek": "Trong Tuần này",
    "message.aegOutboundOrderDetail.title.storeCode": "Cửa Hàng Mã",
    "message.aegOutboundOrderDetail.consignColumn.supplierName": "Nhà cung cấp Tên",
    "message.transform.bind": "RÀNG BUỘC",
    "message.table.fulfillment.action": "Hành động",
    "message.aegInboundDetail.title.storeCode": "Cửa Hàng Mã",
    "message.views.inventoryLedger.inventoryTypeMap.good": "TỐT",
    "message.aegInboundDetail.title.basicInformation": "Thông Tin cơ bản",
    "message.lzdInboundPlanView.replenishColumns.scItemName": "Fulfilment MÃ HÀNG Tên",
    "message.outboundView.table.creator": "Đấng tạo hóa",
    "message.views.stockAllocation.adjustRuleSuccess": "Điều chỉnh Quy Tắc Thành Công",
    "message.button.search": "Tìm kiếm",
    "message.aegOutboundOrderDetail.consignColumn.reserveOrderNo": "Dự trữ Không Có.",
    "message.views.scItemView.manufacturePackageDimensions": "Sản xuất Trọn Gói Kích Thước",
    "message.inboundView.button.createOutboundBtn": "Tạo ra Mới OO",
    "message.inboundView.title.createTime": "Tạo ra Thời Gian",
    "message.table.fulfillment.buyerId": "Người mua ID",
    "message.views.workbench.totalGmv": "Tổng Gmv",
    "message.aegInboundDetail.title.channel": "Kênh",
    "message.transform.orderCheck": "ICP/IO thứ tự Kiểm Tra",
    "message.message.fulfillment.chooseOneOrder": "Lựa chọn ít nhất một đơn hàng cho giao hàng!",
    "message.views.dashboardScore.dashboardName.all_order_quantity": "Tổng số Đơn Đặt Hàng Số Lượng",
    "message.outboundView.button.template": "Mẫu",
    "message.table.fulfillment.orderStatusDesc": "Tình Trạng đặt hàng",
    "message.views.scItemView.platformSku": "PlatformSku",
    "message.inboundView.button.exportSelectedOrder": "Xuất khẩu Được Lựa Chọn Thứ Tự",
    "message.views.dashboardScore.table.operation": "Hoạt động",
    "message.views.publishTemplateView.operation": "Hoạt động",
    "message.aegInboundDetail.logisticColumn.operateTime": "Hoạt động Thời Gian",
    "message.views.workbench.orderQuantityTendency": "Số Lượng đặt hàng Xu Hướng",
    "message.views.productPublishView.inputSearchText": "Đầu vào các tìm kiếm văn bản",
    "message.views.inventoryLedger.inventoryTypeMap.defective": "BỊ LỖI",
    "message.inboundView.table.creator": "Đấng tạo hóa",
    "message.table.fulfillment.shippingType": "Vận chuyển Loại Mã",
    "message.inboundView.table.supplier": "Nhà cung cấp",
    "message.views.scItemView.basicInfo": "Thông Tin cơ bản",
    "message.views.scItemView.fulfillmentSkuDetail": "FulfillmentSku Chi Tiết",
    "message.common.detail": "Chi tiết",
    "message.lzdInboundCreateView.addSkuView.queryView.fulfilmentSku": "Fulfilment Mã Hàng",
    "message.aegOutboundOrderDetail.title.remark": "Nhận xét",
    "message.views.workbench.dashboardDescription.totalProductSoldQuantity": "Tổng Sản Phẩm Bán: Tổng số lượng của hàng hóa trong tất cả các kho ban hành đơn đặt hàng. Bảng điều khiển nội dung: Sản phẩm khối lượng bán hàng dữ liệu trong các cuối cùng bảy ngày làm việc. Hàng ngày Sản Phẩm Được Bán: Tổng số lượng của hàng hóa trong tất cả các kho Ban Hành đơn đặt hàng Ngày Hôm Nay",
    "message.views.productPublishView.upload": "Tải lên",
    "message.transform.bindFailedAndDownload": "Hàng tồn kho Ràng Buộc Không Thành Công, Tải Về Thất Bại Thông Tin Chi Tiết",
    "message.common.fulfillment.ship": "Free ship",
    "message.inboundView.button.search": "Tìm kiếm",
    "message.views.activityInventory.fulfillmentSkuCode": "Thực hiện SKU Code",
    "message.lzdOutboundViewDetail.title.inLbxOrderCode": "Fulfilment Đặt Hàng Không Có.",
    "message.views.liveInventory.commodity": "Hàng hóa",
    "message.views.inventoryLedger.orderTypeMap.CHECK_OUT": "Chu kỳ Đếm Giảm Cân",
    "message.views.inventoryLedger.orderTypeMap.COORDINATE_OUT": "Kho Chuyển Outbound",
    "message.views.scItemView.status": "Tình trạng",
    "message.views.scItemView.downShelf": "Xuống Kệ",
    "message.views.productPublishView.category": "Category",
    "message.outboundView.table.merchantCode": "Thương gia Mã",
    "message.login.switch_to_in_id": "Beralih ke bahasa Indonesia",
    "message.menu.publishTemplateView": "Mẫu",
    "message.lzdInboundCreateView.title.skuFlag": "SKU",
    "message.inboundView.table.detail": "Chi tiết",
    "message.views.inventoryReconciliation.changeTypeMap.totalLost": "Bị mất",
    "message.views.liveInventory.shopName": "Cửa hàng Tên",
    "message.transform.shipperCheck": "Người gửi hàng Kiểm Tra",
    "message.views.productView.sellerSku": "Người Bán MÃ HÀNG",
    "message.views.inventoryLedger.inventoryTypeMap.transferOnWay": "CHUYỂN TRÊN CÁCH",
    "message.views.scItemView.searchButton": "Tìm kiếm",
    "message.views.inventoryReconciliation.stockChange": "Cổ Phong Trào",
    "message.card.fulfillment.tradeCreateTime": "Thương mại Tạo Ra Thời Gian",
    "message.lzdInboundDetail.title.sellerInformation": "Người Bán Thông Tin",
    "message.inboundView.alert.cancel": "Hủy bỏ",
    "message.card.fulfillment.promiseLatestDate": "Lời Hứa Ngày Mới Nhất",
    "message.views.inventoryLedger.orderTypeMap.IMBALANCE_LOCK": "Kho khóa",
    "message.menu.feedback.feedback": "Thông tin phản hồi",
    "message.views.workbench.authorizationShop": "Ủy quyền Cửa Hàng",
    "message.transform.firstStep": "Bước đầu tiên",
    "message.views.workbench.totalOrderQuantity": "Tổng số Đơn Đặt Hàng Số Lượng",
    "message.lzdInboundCreateView.tableColumn.contactInfo": "Liên hệ với",
    "message.outboundView.button.exportBtn": "Xuất khẩu",
    "message.menu.inventoryReconciliation": "Hàng tồn kho Hòa Giải",
    "message.views.workbench.channelSales": "Kênh Gmv",
    "message.transform.inventoryBind": "Hàng tồn kho RÀNG BUỘC",
    "message.views.workbench.dailyGmv": "Hàng ngày Gmv",
    "message.menu.createNewOutboundOrder": "Tạo ra Mới Outbound Thứ Tự",
    "message.aegInboundDetail.goodsTable.normalQtyDec": "Bình thường Số Lượng.",
    "message.views.scItemView.itemSite": "Sản phẩm Trang Web",
    "message.views.stockAllocation.channelName": "Tên kênh",
    "message.lzdInboundDetail.title.basicInformation": "Thông Tin cơ bản",
    "message.lzdInboundDetail.title.purchaseOrderCode": "Đơn Đặt Hàng Không Có",
    "message.aegInboundDetail.title.skus": "SKU",
    "message.lzdInboundCreateView.tableColumn.sellerCountry": "Người bán Nước",
    "message.aegInboundDetail.logisticColumns.fulfillStatusDesc": "Mô tả trạng thái",
    "message.inboundView.title.warehouseList": "Gửi đến Kho",
    "message.CreateTransferOrder.entityCode": "Nguồn Kho",
    "message.table.fulfillment.scItemName": "SC Item Name",
    "message.inboundView.button.LzdTemplate": "Lazada",
    "message.card.fulfillment.receiverProvince": "Receiver Tỉnh",
    "message.card.fulfillment.tradeOrderId": "Thương mại ID Đặt Hàng",
    "message.aegInboundDetail.title.cancelTime": "Hủy Thời Gian",
    "message.views.productView.status": "Tình trạng",
    "message.views.stockAllocation.allMoreThan100": "Tất cả các tỷ lệ không được phép hơn 100, xin vui lòng điều chỉnh.",
    "message.aegOutboundOrderDetail.title.skuVariety": "Mã hàng",
    "message.card.fulfillment.orderStatus": "Tình Trạng đặt hàng",
    "message.views.inventoryReconciliation.changeTypeMap.totalSellerInboundedStock": "Người Bán Inbounded",
    "message.aegInboundDetail.logisticColumns.operator": "Nhà điều hành",
    "message.views.liveInventory.warehouse": "Kho",
    "message.drawer.fulfillment.shippingType": "Vận chuyển Loại",
    "message.aegOutboundOrderDetail.consignColumn.inboundNo": "Hậu cần Không Có.",
    "message.lzdInboundDetail.lzdItemTable.scItemId": "Item ID",
    "message.views.inventoryLedger.orderTypeMap.PURCHASE_IN": "Người bán/Nhà Cung Cấp Gửi Đến",
    "message.views.activityInventory.expireTime": "Hết hạn Thời Gian",
    "message.transform.downloadErrorFileUrl": "Lỗi Tập Tin Tải Về Liên Kết",
    "message.drawer.fulfillment.shippingName": "Vận chuyển Tên",
    "message.button.reset": "Thiết lập lại",
    "message.login.log_out": "Đăng nhập Ra",
    "message.views.workbench.merchantCode": "Thương gia",
    "message.lzdInboundPlanView.queryForm.scItemCode": "Fulfilment MÃ HÀNG",
    "message.views.scItemView.deleteRelatedPlatformSku": "Xóa mục liên quan",
    "message.views.inventoryLedger.orderTypeMap.OTHER": "KHÁC",
    "message.views.inventoryReconciliation.ledgerDetail": "Sổ cái Chi Tiết",
    "message.taskCenterView.table.creator": "Đấng tạo hóa",
    "message.views.workbench.totalItemSold": "Tổng Mục Bán",
    "message.lzdInboundDetail.lzdItemTable.itemRequested": "Mục Yêu Cầu",
    "message.views.inventoryReconciliation.changeTypeMap.totalOtherOutbounded": "Khác Outbounded",
    "message.lzdInboundDetail.title.inboundOrderCode": "Gửi đến Đặt Hàng Không Có",
    "message.transform.startTime": "Thời Gian bắt đầu",
    "message.lzdOutboundViewDetail.title.estimateTimeStr": "Thời Gian dự kiến",
    "message.table.fulfillment.warehouseName": "Kho Tên",
    "message.aegInboundDetail.title.purchaseOrderCode": "Đơn Đặt Hàng Mã",
    "message.views.scItemView.bindRelatedPlatformSku": "Ràng buộc tài liệu liên quan",
    "message.lzdInboundDetail.title.warehouseAddress": "Kho Địa Chỉ",
    "message.lzdInboundDetail.title.estimateTime": "Thời Gian dự kiến",
    "message.table.fulfillment.receiverMobile": "Receiver Di Động",
    "message.card.fulfillment.orderInformation": "Thông Tin đặt hàng",
    "message.inboundView.title.fulfilmentOrderCode": "Fulfilment Đặt Hàng Không Có.",
    "message.aegInboundDetail.title.expectedTime": "Thời Gian dự kiến",
    "message.views.scItemView.productType": "Loại sản phẩm",
    "message.views.productPublishView.plsChooseTemplateToPublish": "Bạn có thể chọn một mẫu để xuất bản",
    "message.outboundView.table.outboundOrder": "Outbound Thứ Tự",
    "message.card.fulfillment.shipperId": "Đặt hàng Chủ Sở Hữu ID",
    "message.views.inventoryReconciliation.changeTypeMap.totalShipped": "Vận chuyển đến Khách Hàng",
    "message.table.fulfillment.itemName": "Item Name",
    "message.table.fulfillment.orderItemStatusDesc": "Mục đặt hàng Tình Trạng",
    "message.aegInboundDetail.goodsTable.scItemId": "Fulfilment MÃ HÀNG",
    "message.lzdOutboundViewDetail.title.deliverTypeName": "Cung cấp Loại Tên",
    "message.views.activityInventory.activeTime": "Hoạt động Thời Gian",
    "message.views.inventoryReconciliation.startDateStock": "Ngày bắt đầu Cổ",
    "message.table.fulfillment.cbFulfillmentOrderItemId": "CB THỰC Hiện Mục Đặt Hàng ID",
    "message.views.liveInventory.sellable": "Sellable",
    "message.menu.inventory": "Hàng tồn kho",
    "message.transform.authStore": "Ủy quyền Cửa Hàng",
    "message.table.fulfillment.receiverAddress": "Địa Chỉ người nhận",
    "message.views.productPublishView.pleaseChooseTheShop": "Xin vui lòng chọn các cửa hàng",
    "message.views.workbench.deliver": "Cung cấp",
    "message.button.submit": "Gửi",
    "message.menu.demoDashboard": "Bảng điều khiển Bản Demo",
    "message.inboundView.table.skuQuantity": "Số lượng",
    "message.views.productView.platformSku": "PlatformSku",
    "message.views.inventoryReconciliation.changeTypeMap.totalReturnToSeller": "Người Bán Outbounded",
    "message.outboundView.title.fulfilmentOrderCode": "Fulfilment Đặt Hàng Không Có.",
    "message.aegOutboundOrderDetail.title.storeName": "Tên cửa hàng",
    "message.table.fulfillment.cbOrderStatus": "CB Tình Trạng Đặt Hàng Mã",
    "message.table.fulfillment.orderItemStatusReason": "Mục đặt hàng Tình Trạng Lý Do",
    "message.views.productPublishView.templateDetail": "Mẫu Chi Tiết",
    "message.inboundView.table.orderQuantity": "Số Lượng đặt hàng",
    "message.views.workbench.productSold": "Sản phẩm Được Bán",
    "message.aegOutboundOrderDetail.consignColumn.creator": "Đấng tạo hóa",
    "message.views.inventoryLedger.orderTypeMap.REFOUND_IN": "Thực hiện Xếp Gửi Đến",
    "message.aegInboundDetail.title.batchInformation": "Hàng loạt Thông Tin",
    "message.transform.upStep": "Trước đó",
    "message.views.productView.itemId": "Item ID",
    "message.taskCenterView.table.gmtCreated": "Tạo ra Thời Gian",
    "message.inboundView.table.inboundOrder": "Gửi đến Không Có.",
    "message.inboundView.table.cancel": "Hủy bỏ",
    "message.aegOutboundOrderDetail.logisticColumns.bizOrderNo": "Biz Đặt Hàng Không Có",
    "message.transform.failed": "Thất Bại",
    "message.table.fulfillment.quantity": "Số lượng",
    "message.views.inventoryReconciliation.changeTypeMap.totalFound": "Tìm thấy",
    "message.views.scItemView.itemCode": "ItemCodes",
    "message.select.fulfillment.deliverySuccess": "Giao hàng Thành Công",
    "message.table.fulfillment.cbFulfillmentOrderId": "CB THỰC Hiện ID Đặt Hàng",
    "message.table.fulfillment.tradeCreateTime": "Thương mại Tạo Ra Thời Gian",
    "message.outboundView.table.warehouse": "Kho",
    "message.aegOutboundOrderDetail.consignColumn.purchaseOrderNo": "Outbound Không Có.",
    "message.transform.transferred": "Chuyển giao",
    "message.views.liveInventory.seller": "Người bán",
    "message.views.productView.itemSite": "Trang web",
    "message.menu.productView": "Sản phẩm",
    "message.card.fulfillment.tradeOrderItemId": "Đơn Đặt Hàng thương mại Item ID",
    "message.views.scItemView.updateScItemButton": "Cập nhật Gửi",
    "message.lzdInboundCreateView.addSkuView.goodQuantity": "Tốt Số Lượng",
    "message.lzdOutboundViewDetail.title.orderStatusName": "Tình trạng",
    "message.transform.secondStep": "Bước thứ hai",
    "message.login.language": "Ngôn ngữ",
    "message.views.workbench.quantity": "Số lượng",
    "message.menu.fulfillmentOrder": "Thứ tự",
    "message.outboundView.button.exportSelectedOrder": "Xuất khẩu Được Lựa Chọn Thứ Tự",
    "message.aegInboundDetail.title.warehouseAddress": "Địa chỉ",
    "message.aegOutboundOrderDetail.consignColumn.gmtConfirmReceiveStr": "Xác Nhận Đã Nhận Được Thời Gian",
    "message.views.inventoryLedger.orderType": "Đặt hàng Loại",
    "message.taskCenterView.table.errorMsg": "Thông Báo lỗi",
    "message.views.inventoryAging.1-30day": "1-30 ngày",
    "message.table.fulfillment.orderStatus": "Tình Trạng đặt hàng Mã",
    "message.table.fulfillment.cbOrderStatusDesc": "CB Tình Trạng Đặt Hàng",
    "message.views.inventoryAging.inventoryType": "Loại hàng tồn kho",
    "message.transform.authList": "Ủy quyền Danh Sách",
    "message.views.feedback.feedbackOptions.questionFeedback": "Câu hỏi Thông Tin Phản Hồi",
    "message.transform.operateStore": "Hoạt động Cửa Hàng",
    "message.lzdOutboundViewDetail.title.sellerInformation": "Người Bán Thông Tin",
    "message.views.scItemView.logisticsAttributes": "Hậu cần Các Thuộc Tính",
    "message.outboundView.button.LzdTemplate": "Lazada Mẫu",
    "message.views.scItemView.sellerSku": "Người Bán Mã Hàng",
    "message.lzdInboundDetail.title.orderStatus": "Tình trạng",
    "message.menu.cbFulfillmentOrder": "Xuyên biên giới Thứ Tự",
    "message.aegOutboundOrderDetail.title.totalReturnQuantity": "Trở lại Số Lượng",
    "message.views.workbench.noReplenishment": "Không có Bổ Sung Kế Hoạch",
    "message.drawer.fulfillment.deliverySuccess": "Giao hàng Thành Công",
    "message.views.workbench.dashboardDescription.totalOrderQuantity": "Tất cả các Mặt Hàng Bán: Sum của tất cả các kho đơn đặt hàng, Hàng Tuần Tỷ Lệ: (số lượng đặt hàng của trong tuần này-Số lượng đặt hàng của trong tuần này của cuối cùng năm)/Số lượng đặt hàng của trong tuần này của cuối cùng năm, hàng ngày Tỷ Lệ (số lượng đặt hàng của ngày hôm nay-Số lượng đặt hàng của Ngày Hôm nay của cuối cùng năm) /Số lượng đặt hàng của Ngày Hôm nay của cuối cùng năm, ngày số lượng đặt hàng: sum của đơn đặt hàng của Ngày Hôm Nay",
    "message.table.fulfillment.itemDiscountFee": "Mục Giảm Giá Phí",
    "message.aegInboundDetail.title.logisticLogs": "Hậu cần Bản Ghi",
    "message.views.productPublishView.pleaseSelectTheCategory": "Xin vui lòng chọn các loại",
    "message.aegOutboundOrderDetail.title.orderStatus": "Tình Trạng đặt hàng",
    "message.views.inventoryLedger.resultQuantity": "Kết quả Số Lượng",
    "message.CreateTransferOrder.estimatedOutboundTime": "Ước tính Outbound thời gian",
    "message.aegInboundDetail.logisticColumns.operateTime": "Thời gian hoạt động",
    "message.views.productPublishView.publishTemplate": "Xuất Bản Mẫu",
    "message.lzdInboundDetail.title.deliverType": "Cung cấp Loại",
    "message.outboundView.table.platform": "Nền Tảng",
    "message.outboundView.button.importBtn": "Nhập khẩu",
    "message.outboundView.table.operate": "Hoạt động",
    "message.views.stockAllocation.cancel": "Hủy bỏ",
    "message.views.activityInventory.platformSkuCode": "Nền tảng Mã Hàng Mã",
    "message.views.liveInventory.warehouseCode": "Kho Mã",
    "message.lzdInboundCreateView.addSkuView.serialNumber": "Nối tiếp Số",
    "message.form.fulfillment.merchantList": "Thương gia",
    "message.views.scItemView.brand": "Thương hiệu",
    "message.modal.pdfContext": "Đi để in hoặc tải về",
    "message.aegOutboundOrderDetail.title.returnOrderNO": "Trả lại Hàng Không Có.",
    "message.views.productPublishView.batchPublish": "Hàng loạt Xuất Bản",
    "message.views.workbench.thisQuarter": "Quý này",
    "message.lzdInboundCreateView.tableColumn.submitBtn": "Gửi",
    "message.transform.inventoryCheck": "Hàng tồn kho Kiểm Tra",
    "message.form.fulfillment.tradeCreateTime": "Tạo ra Thời Gian",
    "message.CreateTransferOrder.receiverAddress": "Địa Chỉ người nhận",
    "message.views.scItemView.serialNumberManagement": "Nối tiếp Số Quản Lý",
    "message.button.save": "Tiết kiệm",
    "message.table.fulfillment.receiverPhone": "Receiver Điện Thoại",
    "message.views.publishTemplateView.search": "Tìm kiếm",
    "message.views.stockAllocation.search": "Tìm kiếm",
    "message.form.fulfillment.siteList": "Trang web",
    "message.lzdInboundDetail.lzdItemTable.goodsBarcode": "Tốt Mã Vạch",
    "message.views.publishTemplateView.shortDesc": "Mô Tả ngắn",
    "message.views.workbench.toInbound": "Để Gửi Đến",
    "message.aegInboundDetail.goodsTable.quantityDec": "Mua Số Lượng",
    "message.views.inventoryAging.91-120day": "91-120 ngày",
    "message.menu.workbench": "Bàn làm việc",
    "message.lzdInboundCreateView.title.sellerAddress": "Người Bán Địa Chỉ",
    "message.lzdInboundCreateView.addSkuView.queryView.platformSku": "Nền tảng Mã Hàng",
    "message.card.fulfillment.warehouseCode": "Kho Mã",
    "message.lzdOutboundViewDetail.title.sellerName": "Người Bán Tên",
    "message.table.fulfillment.receiverCity": "Receiver Thành Phố",
    "message.lzdInboundCreateView.title.basicFlag": "Thông Tin cơ bản",
    "message.views.workbench.gmvRank": "GMV Xếp Hạng",
    "message.lzdInboundCreateView.addSkuView.quantity": "Yêu cầu Số Lượng",
    "message.views.scItemView.temperatureCondition": "Điều Kiện nhiệt độ",
    "message.views.liveInventory.platform": "Nền Tảng",
    "message.outboundView.button.AegTemplate": "AE Mẫu",
    "message.views.dashboardScore.dashboardName.inventory_turn_over": "Hàng tồn kho Lần Lượt Qua",
    "message.card.fulfillment.receiverAddress": "Địa Chỉ người nhận",
    "message.transform.ae.description": "AE Cửa Hàng Ràng Buộc Lối Vào",
    "message.views.workbench.orderTime": "Thời Gian đặt hàng",
    "message.form.fulfillment.inputTrackingNumber": "Xin vui lòng nhập vào Số theo dõi!",
    "message.menu.fulfillmentPackageDetail": "Thực hiện Chi Tiết Gói",
    "message.transform.itemCheck": "PlatformSku/FulfillmentSku Kiểm Tra",
    "message.views.workbench.fulfillmentOrderId": "Thực hiện ID Đặt Hàng",
    "message.views.stockAllocation.inChannel": "Trong Kênh",
    "message.views.inventoryLedger.orderCode": "Đặt Hàng Mã",
    "message.table.fulfillment.receiverProvince": "Receiver Tỉnh",
    "message.lzdOutboundViewDetail.title.address": "Địa chỉ",
    "message.views.inventoryLedger.orderTypeMap.OTHER_INBOUND": "Khách hàng Trở Lại Gửi Đến",
    "message.form.fulfillment.plName": "Giao hàng Nhà Cung Cấp",
    "message.transform.record": "Gần đây Bị Ràng Buộc Ghi Lại",
    "message.CreateTransferOrder.senderAddress": "Tên người gửi Địa Chỉ",
    "message.aegOutboundOrderDetail.consignColumn.formatPreArriveTime": "Trước khi Đến Thời Gian",
    "message.select.fulfillment.completeShipping": "Gửi Tất Cả Các",
    "message.outboundView.title.createTime": "Tạo ra Thời Gian",
    "message.views.productView.skuStock": "MÃ HÀNG Cổ",
    "message.views.productView.searchButton": "Tìm kiếm",
    "message.transform.shopBindFailed": "Cửa hàng Ràng Buộc Thất Bại",
    "message.views.workbench.allShop": "Tất cả các Cửa Hàng",
    "message.inboundView.button.AegTemplate": "AE Toàn Cầu",
    "message.views.scItemView.shop": "Cửa hàng",
    "message.views.scItemView.itemId": "ProductID",
    "message.taskCenterView.table.downLoad": "Tải về",
    "message.menu.dashboard": "Bảng điều khiển",
    "message.views.workbench.wow": "Hàng tuần Tỷ Lệ",
    "message.taskCenterView.title.taskStatus": "TaskStatus",
    "message.lzdInboundCreateView.addSkuView.addSkuTitle": "Thêm Mã Hàng",
    "message.outboundView.table.cancel": "Hủy bỏ",
    "message.views.workbench.channelItemSold": "Kênh Mục Bán",
    "message.views.scItemView.platformSkuDetail": "PlatformSku Chi Tiết",
    "message.aegOutboundOrderDetail.purchaseItemColumn.remark": "Nhận xét",
    "message.menu.authorization.auth": "Auth",
    "message.menu.productPublishView": "Sản phẩm Xuất Bản",
    "message.outboundView.table.receivedQuantity": "Nhận được Số Lượng",
    "message.views.stockAllocation.ratio": "Tỷ lệ",
    "message.aegOutboundOrderDetail.purchaseItemColumn.title": "Tiêu đề",
    "message.views.scItemView.scItemMerchant": "FulfillmentSku Thương Gia",
    "message.transform.unfinished": "Chưa hoàn thành",
    "message.views.workbench.dailyProductSold": "Hàng ngày Sản Phẩm Được Bán",
    "message.views.activityInventory.channelCode": "Kênh Mã",
    "message.lzdInboundDetail.lzdItemTable.itemCompleted": "Mục Hoàn Thành",
    "message.views.feedback.feedbackType": "Vấn đề Loại",
    "message.card.fulfillment.receiverCountry": "Thu Nước",
    "message.outboundView.table.supplier": "Nhà cung cấp",
    "message.taskCenterView.table.taskId": "Nhiệm vụ ID",
    "message.views.scItemView.width": "Chiều rộng",
    "message.transform.isSuccess": "Là Thành Công",
    "message.lzdInboundDetail.lzdItemTable.scItemCode": "Item Code",
    "message.views.workbench.operation": "Hoạt động",
    "message.views.stockAllocation.stockAllocation": "Điều chỉnh Cổ",
    "message.aegInboundDetail.purchaseItemColumn.receivedDefectiveQtyDec": "Nhận được Bị Lỗi Số Lượng",
    "message.views.stockAllocation.outChannel": "Ra Kênh",
    "message.aegInboundDetail.title.cancelReason": "Hủy Lý Do",
    "message.views.productPublishView.brand": "Thương hiệu",
    "message.transform.startBind": "Bắt đầu Cửa Hàng Ràng Buộc Kiểm Tra",
    "message.transform.bindCheckSuccess": "Hàng tồn kho Ràng Buộc Kiểm Tra Đã Thành Công",
    "message.aegOutboundOrderDetail.title.logisticOrderCode": "Hậu cần Thứ Tự Mã",
    "message.table.fulfillment.sellerId": "Người Bán ID",
    "message.aegOutboundOrderDetail.logisticColumns.operator": "Nhà điều hành",
    "message.card.fulfillment.deliveryInfomation": "Thông Tin giao hàng",
    "message.card.fulfillment.trackingNumber": "Theo dõi Số",
    "message.menu.feedback.dashboardScore": "Bảng điều khiển Điểm Số",
    "message.outboundView.button.exportAllOrder": "Xuất khẩu Các Đơn Hàng",
    "message.lzdInboundCreateView.tableColumn.deleteBtn": "Xóa",
    "message.views.publishTemplateView.addTemplate": "Thêm Mẫu",
    "message.table.fulfillment.receiverCountry": "Thu Nước",
    "message.views.workbench.orderQuantity": "Số Lượng đặt hàng",
    "message.aegInboundDetail.purchaseItemColumn.sentQty": "Gửi Số Lượng.",
    "message.views.productPublishView.import": "Nhập khẩu",
    "message.views.inventoryLedger.orderTypeMap.ADJUST_IN": "Điều chỉnh trong",
    "message.aegOutboundOrderDetail.purchaseItemColumn.returnQtyDec": "Trở lại Số Lượng",
    "message.views.dashboardScore.table.dashboardName": "Bảng điều khiển Tên",
    "message.aegInboundDetail.title.cancelPerson": "Hủy bỏ Người",
    "message.transform.bindException": "Hàng tồn kho Ràng Buộc Ngoại Lệ",
    "message.lzdOutboundViewDetail.title.sellerAddress": "Người Bán Địa Chỉ",
    "message.inboundView.button.createInboundBtn": "Tạo ra Mới IO",
    "message.form.fulfillment.cbFulfillmentOrderId": "CB THỰC Hiện ID Đặt Hàng",
    "message.aegInboundDetail.logisticColumns.bizOrderNo": "Dòng Chảy Số",
    "message.views.scItemView.reload": "Rõ ràng Lựa Chọn",
    "message.aegOutboundOrderDetail.title.outboundTime": "Outbound Thời Gian",
    "message.aegInboundDetail.title.expiredTime": "Hết hạn Thời Gian",
    "message.aegOutboundOrderDetail.purchaseItemColumn.quantityDec": "Số lượng",
    "message.CreateTransferOrder.senderCountry": "Tên người gửi Nước",
    "message.views.publishTemplateView.operator": "Nhà điều hành",
    "message.transform.shopBinding": "Cửa hàng RÀNG BUỘC",
    "message.aegOutboundOrderDetail.title.basicInformation": "Thông Tin cơ bản",
    "message.views.workbench.productSoldRank": "Sản phẩm Được Bán Xếp Hạng",
    "message.inboundView.table.receivedQuantity": "Nhận được Số Lượng",
    "message.views.inventoryAging.greate180day": "Hơn 180 Ngày",
    "message.select.fulfillment.deliveryFailed": "Giao hàng Thất Bại",
    "message.button.printPdf": "In PDF",
    "message.form.fulfillment.deliveryType": "Giao hàng Xác Nhận",
    "message.views.stockAllocation.scItemId": "ScItemId",
    "message.drawer.fulfillment.trackingNumbers": "Số theo dõi",
    "message.aegOutboundOrderDetail.title.skus": "Mã hàng",
    "message.inboundView.table.merchantCode": "Thương gia Mã",
    "message.aegInboundDetail.goodsTable.barcode": "Mã vạch",
    "message.card.fulfillment.itemInfomation": "Mục Thông Tin",
    "message.table.fulfillment.totalItemFee": "Tổng Mục Phí",
    "message.views.inventoryAging.61-90day": "61-90 ngày",
    "message.menu.inboundPlanItem": "Bổ sung",
    "message.aegInboundDetail.purchaseItemColumn.measureUnit": "Đơn Vị đo lường",
    "message.views.scItemView.height": "Chiều cao",
    "message.views.workbench.skuNum": "Mã hàng Nums",
    "message.views.workbench.dashboardDescription.inventoryTurnOver": "Hàng tồn kho doanh thu: Khối lượng bán hàng/trung bình hàng tồn kho trong các cuối cùng tháng",
    "message.transform.shopBindException": "Cửa hàng Ràng Buộc Ngoại Lệ",
    "message.lzdInboundCreateView.addSkuView.operate": "Hoạt động",
    "message.views.inventoryReconciliation.dateRange": "Ngày Phạm Vi",
    "message.views.stockAllocation.sellableStock": "Thể bán Cổ",
    "message.views.stockAllocation.warehouse": "Kho",
    "message.inboundView.title.orderStatus": "Tình trạng",
    "message.inboundView.alert.selectFile": "Tập tin Được Lựa Chọn",
    "message.form.fulfillment.orderStatus": "Tình Trạng đặt hàng",
    "message.inboundView.alert.sure": "Xác nhận",
    "message.views.inventoryAging.skuVolumn": "MÃ HÀNG Volumn",
    "message.transform.bindCheckFailed": "Hàng tồn kho Ràng Buộc Kiểm Tra Thất Bại",
    "message.views.workbench.toDeliver": "Để Cung Cấp",
    "message.common.reset": "Thiết lập lại",
    "message.transform.toTransfer": "Để Chuyển",
    "message.views.workbench.dailyItemSold": "Hàng ngày Mục Bán",
    "message.views.stockAllocation.adjustRuleFailed": "Điều chỉnh Quy Tắc Thất Bại",
    "message.aegInboundDetail.title.createTime": "Tạo ra Thời Gian",
    "message.transform.selectShop": "Chọn Cửa Hàng",
    "message.views.productView.skuStatus": "MÃ HÀNG Tình Trạng",
    "message.views.productPublishView.skuImage": "Mã hàng Hình Ảnh",
    "message.views.feedback.feedbackContent": "FeedbackContent",
    "message.lzdInboundCreateView.title.sellerFlag": "Người Bán Thông Tin",
    "message.views.activityInventory.search": "Tìm kiếm",
    "message.aegOutboundOrderDetail.consignColumn.operate": "Hoạt động",
    "message.table.fulfillment.orderType": "Đặt hàng Loại",
    "message.inboundView.title.shopName": "Cửa hàng",
    "message.views.inventoryAging.fulfillmentSkuCode": "Thực hiện SKU Code",
    "message.views.dashboardScore.dashboardName.effect_of_operation_activity": "Hiệu quả Của Hoạt Động Hoạt Động",
    "message.inboundView.table.orderStatus": "Tình trạng",
    "message.views.dashboardScore.dashboardName.all_product_sold": "Tổng Sản Phẩm Được Bán",
    "message.table.fulfillment.skuId": "Mã hàng ID",
    "message.card.fulfillment.promiseEarliestDate": "Lời Hứa Sớm Nhất Ngày",
    "message.aegInboundDetail.btn.detail": "Chi tiết",
    "message.views.workbench.ito": "Hàng tồn kho Lần Lượt Qua",
    "message.card.fulfillment.buyerId": "Người mua ID",
    "message.transform.selectStoresToBindInventory": "Chọn Cửa Hàng Để Ràng Buộc Hàng Tồn Kho",
    "message.CreateTransferOrder.destEntityCode": "Đích Kho",
    "message.views.scItemView.barcode": "Mã vạch",
    "message.views.dashboardScore.dashboardName.to_supplement": "Để Bổ Sung",
    "message.table.fulfillment.fulfillmentOrderId": "Thực hiện ID Đặt Hàng",
    "message.table.fulfillment.cod": "COD",
    "message.transform.success": "Thành Công",
    "message.select.fulfillment.partialShipping": "Một phần Vận Chuyển",
    "message.views.stockAllocation.fulfillmentSkuCode": "Thực hiện SKU Code",
    "message.outboundView.title.orderStatus": "Tình Trạng đặt hàng",
    "message.transform.InventoryBinding": "Hàng tồn kho RÀNG BUỘC",
    "message.views.workbench.today": "Ngày Hôm Nay",
    "message.views.productView.operation": "Hoạt động",
    "message.table.fulfillment.siteId": "Trang web ID",
    "message.transform.shopBindFailedAndDownload": "Cửa hàng Ràng Buộc Không Thành Công, Tải Về Thất Bại Thông Tin Chi Tiết",
    "message.form.fulfillment.reverseTradeOrderId": "Thứ Tự ngược lại ID",
    "message.views.productView.merchant": "Thương gia",
    "message.transform.finished": "Hoàn thành",
    "message.views.stockAllocation.submit": "Gửi",
    "message.views.stockAllocation.fulfillmentSkuName": "Thực hiện Mã Hàng Tên",
    "message.views.publishTemplateView.templateDetail": "Mẫu Chi Tiết",
    "message.menu.authorization.title": "Ủy Quyền",
    "message.views.scItemView.platformTitle": "PlatformSku Tiêu Đề",
    "message.transform.startShopBind": "Bắt đầu Cửa Hàng RÀNG BUỘC",
    "message.aegOutboundOrderDetail.title.inventoryType": "Loại hàng tồn kho",
    "message.card.fulfillment.receiverInfomation": "Nhận Thông Tin",
    "message.lzdInboundDetail.title.shop": "Cửa hàng",
    "message.form.fulfillment.warehouseCode": "Kho Mã",
    "message.outboundView.button.search": "Tìm kiếm",
    "message.views.workbench.suggestToReplenish": "Đề nghị để Bổ Sung",
    "message.views.inventoryAging.150-180day": "150-180 ngày",
    "message.table.fulfillment.actualItemPaidFee": "Mặt Hàng thực tế Thanh Toán Phí",
    "message.table.fulfillment.scItemId": "SC Item ID",
    "message.card.fulfillment.receiverCity": "Receiver Thành Phố",
    "message.views.scItemView.showRelation": "Hiển thị Mối Quan Hệ",
    "message.inboundView.title.platform": "Nền Tảng",
    "message.aegInboundDetail.logisticColumn.bizOrderNo": "Biz Đặt Hàng Không Có",
    "message.aegInboundDetail.title.actualArrivalTime": "Thực tế Thời Gian Đến",
    "message.views.inventoryLedger.inventoryType": "Loại hàng tồn kho",
    "message.outboundView.table.outboundReason": "Outbound Lý Do",
    "message.lzdOutboundViewDetail.title.basicInformation": "Thông Tin cơ bản",
    "message.table.fulfillment.shippingTypeDesc": "Vận chuyển Loại",
    "message.login.switch_to_vi_vn": "Chuyển sang tiếng Việt",
    "message.form.fulfillment.shippingTypeDesc": "Vận chuyển Loại",
    "message.modal.pdfTitle": "PDF được tạo ra thành công",
    "message.outboundView.table.outboundTime": "Outbound Thời Gian",
    "message.lzdInboundDetail.title.sellerAddress": "Người Bán Địa Chỉ",
    "message.inboundView.table.warehouse": "Kho",
    "message.menu.inventoryAging": "Hàng tồn kho Lão Hóa",
    "message.lzdInboundCreateView.tableColumn.sellerCity": "Người Bán Thành Phố",
    "message.views.liveInventory.onWayName": "Trên Cách",
    "message.lzdInboundCreateView.tableColumn.addBtn": "Thêm",
    "message.aegOutboundOrderDetail.title.createTime": "Tạo ra Thời Gian",
    "message.views.scItemView.upShelf": "Up Kệ",
    "message.aegOutboundOrderDetail.title.logisticLogs": "Hậu cần Đăng Nhập",
    "message.views.scItemView.merchant": "Thương gia",
    "message.views.liveInventory.cargo": "Vận chuyển hàng hóa",
    "message.lzdOutboundViewDetail.title.userNick": "Hướng dẫn sử dụng Nick",
    "message.card.fulfillment.fulfillmentOrderInformation": "Thực hiện Thông Tin Đặt Hàng",
    "message.menu.outboundItem": "Outbound",
    "message.menu.inventoryLedger": "Hàng tồn kho Sổ Cái",
    "message.common.input": "Đầu vào xin vui lòng",
    "message.views.publishTemplateView.submit": "Gửi",
    "message.table.fulfillment.actualPaidFee": "Thực tế Thanh Toán Phí",
    "message.transform.check": "Hàng tồn kho Ràng Buộc Kiểm Tra",
    "message.views.productView.price": "Giá",
    "message.CreateTransferOrder.receiverPostCode": "Receiver Mã Bưu Điện",
    "message.aegOutboundOrderDetail.title.batchInformation": "Hàng loạt Thông Tin",
    "message.views.inventoryReconciliation.endDateStock": "Ngày kết thúc Cổ",
    "message.views.inventoryAging.averageAge": "Trung bình Tuổi",
    "message.form.fulfillment.fulfillmentOrderId": "Thực hiện ID Đặt Hàng",
    "message.lzdInboundCreateView.addSkuView.resetBtn": "Thiết lập lại",
    "message.outboundView.title.outboundOrderNo": "Outbound Không Có.",
    "message.views.inventoryLedger.orderTypeMap.TRADE_OUT": "Thực hiện Outbound",
    "message.views.workbench.gmv": "GMV",
    "message.lzdOutboundViewDetail.title.logisticLogs": "Hậu cần Đăng Nhập",
    "message.views.inventoryLedger.orderTypeMap.B2B_PURCHASE_IN": "Thất Bại Giao Hàng Gửi Đến",
    "message.views.workbench.channelOrderQuantity": "Kênh Số Lượng Đặt Hàng",
    "message.table.fulfillment.tradeOrderId": "Thương mại ID Đặt Hàng",
    "message.views.dashboardScore.dashboardName.all_authorized_shop": "Tất cả các Ủy Quyền Cửa Hàng",
    "message.views.workbench.currentQuantity": "Hiện tại Số Lượng",
    "message.views.scItemView.gmtModified": "Thay đổi Thời Gian",
    "message.login.switch_to_another_language": "切换为中文",
    "message.views.stockAllocation.channelLock": "Kênh Khóa",
    "message.card.fulfillment.shippingProviderName": "Nhà Cung Cấp vận chuyển Tên",
    "message.CreateTransferOrder.senderTel": "Tên người gửi Tel",
    "message.outboundView.table.skuQuantity": "Số lượng",
    "message.views.dashboardScore.table.rate": "Tỷ lệ",
    "message.views.workbench.all": "Tất cả các",
    "message.views.productPublishView.publishShop": "Xuất bản Cửa Hàng",
    "message.views.activityInventory.campaignName": "Chiến Dịch Tên",
    "message.views.publishTemplateView.longDesc": "Dài Mô Tả",
    "message.views.workbench.totalProductSold": "Tổng Sản Phẩm Được Bán",
    "message.aegOutboundOrderDetail.logisticColumns.operateTime": "Hoạt động Thời Gian",
    "message.aegOutboundOrderDetail.title.supplierId": "Nhà cung cấp ID",
    "message.views.workbench.inbound": "Gửi đến",
    "message.views.productView.barcode": "Mã vạch",
    "message.aegOutboundOrderDetail.purchaseItemColumn.brandName": "Tên thương hiệu",
    "message.table.fulfillment.totalFee": "Tổng số Phí",
    "message.views.inventoryLedger.orderTypeMap.ADJUST_OUT": "Điều chỉnh ra",
    "message.CreateTransferOrder.receiverInfo": "Receiver Thông Tin",
    "message.outboundView.table.createTime": "Tạo ra Thời Gian",
    "message.aegInboundDetail.purchaseItemColumn.scItemId": "Fulfilment MÃ HÀNG",
    "message.menu.liveInventory": "Sống Hàng Tồn Kho",
    "message.aegOutboundOrderDetail.purchaseItemColumn.scItemId": "Item ID",
    "message.views.productView.fulfillmentTitle": "FulfillmentSku Tiêu Đề",
    "message.CreateTransferOrder.receiverTel": "Receiver Tel",
    "message.message.fulfillment.batchShippingMessage": "Bạn chỉ có thể chọn đơn đặt hàng từ một thương gia tại một thời điểm cho lô hàng!",
    "message.login.switch_to_en_us": "Switch To English",
    "message.card.fulfillment.fulfillmentOrderItemId": "Thực hiện Mục Đặt Hàng ID",
    "message.aegInboundDetail.goodsTable.title": "Người Bán MÃ HÀNG",
    "message.inboundView.title.inboundOrder": "Gửi đến đặt hàng Không Có.",
    "message.views.workbench.toReplenishment": "Để Bổ Sung",
    "message.table.fulfillment.warehouseCode": "Kho Mã",
    "message.card.fulfillment.receiverPhone": "Receiver Điện Thoại",
    "message.message.fulfillment.shippingSuccess": "Vận chuyển thành công!",
    "message.views.stockAllocation.platformSkuCode": "Nền tảng Mã Hàng Mã",
    "message.lzdInboundDetail.lzdItemTable.orderItemStatus": "Trạng Thái mục",
    "message.views.workbench.dod": "Hàng ngày Tỷ Lệ",
    "message.transform.waitingMention": "Hàng tồn kho ràng buộc là dự kiến sẽ mất một vài phút, xin vui lòng không đóng trang hiện tại.",
    "message.aegInboundDetail.logisticColumn.operator": "Nhà điều hành",
    "message.lzdInboundDetail.lzdItemTable.scItemName": "Item Name",
    "message.taskCenterView.title.source": "Nguồn",
    "message.lzdInboundCreateView.addSkuView.platformSku": "Nền tảng Mã Hàng",
    "message.lzdInboundDetail.title.skus": "MÃ HÀNG",
    "message.aegInboundDetail.logisticColumn.fulfillStatusDesc": "Thực hiện Tình Trạng Quyết Định",
    "message.table.fulfillment.tradePayTime": "Thương mại Trả Tiền Thời Gian",
    "message.transform.bindCheckException": "Hàng tồn kho Ràng Buộc Kiểm Tra Là Ngoại Lệ",
    "message.card.fulfillment.receiverZip": "Receiver Zip",
    "message.menu.fulfillment": "Thực hiện",
    "message.drawer.fulfillment.ship": "Free ship",
    "message.card.fulfillment.buyerName": "Người mua Tên",
    "message.table.fulfillment.sellerSku": "Người Bán Mã Hàng",
    "message.inboundView.alert.prompt": "Nhanh chóng",
    "message.transform.isDone": "Được Thực Hiện",
    "message.common.search": "Tìm kiếm",
    "message.table.fulfillment.itemTaxActualFee": "Mục Thuế Thực Tế Phí",
    "message.lzdInboundDetail.title.mobile": "Điện thoại di động",
    "message.views.liveInventory.onWay.inBoundOnWay": "Gửi đến OnWay",
    "message.table.fulfillment.tradeOrderItemId": "Đơn Đặt Hàng thương mại Item ID",
    "message.views.scItemView.addRelatedPlatformSku": "Liên quan PlatformSku",
    "message.inboundView.button.exportBtn": "Xuất khẩu",
    "message.views.stockAllocation.adjustStockSuccess": "Điều chỉnh Cổ Thành Công",
    "message.transform.recentBindInventoryRecord": "Gần đây Hàng Tồn Kho Ràng Buộc Kết Quả",
    "message.views.productView.gmtModified": "Thay đổi Thời Gian",
    "message.views.liveInventory.unSellableOccupy": "Dành riêng Unsellable",
    "message.views.inventoryLedger.orderTypeMap.INVENTORY_STATUS_ADJUST_OUT": "Tình trạng hàng tồn kho điều chỉnh",
    "message.views.productView.scItemMerchant": "FulfillmentSku Thương Gia",
    "message.table.fulfillment.reverseTradeOrderId": "Xếp Thương Mại ID Đặt Hàng",
    "message.lzdInboundCreateView.addSkuView.scItemName": "Item Name",
    "message.outboundView.title.returnReason": "Trở lại Lý Do Gì",
    "message.views.productPublishView.atLeastOneImage": "Ít nhất một hình ảnh yêu cầu",
    "message.views.stockAllocation.totalInventory": "Tổng số Hàng Tồn Kho",
    "message.table.fulfillment.receiverZip": "Receiver Zip",
    "message.menu.item": "Sản phẩm/Hàng Hóa",
    "message.aegInboundDetail.purchaseItemColumn.title": "Người Bán MÃ HÀNG",
    "message.card.fulfillment.receiverName": "Tên người nhận",
    "message.inboundView.button.reset": "Thiết lập lại",
    "message.views.feedback.feedbackOptions.systemBug": "Hệ thống Bug",
    "message.CreateTransferOrder.senderInfo": "Tên người gửi Thông Tin",
    "message.card.fulfillment.tradePayTime": "Thương mại Trả Tiền Thời Gian",
    "message.views.productView.platformSkuDetail": "MÃ HÀNG Chi Tiết",
    "message.views.stockAllocation.platformSkuName": "Nền tảng Mã Hàng Tên",
    "message.table.fulfillment.trackingNumbers": "Số theo dõi",
    "message.inboundView.button.exportAllOrder": "Xuất khẩu Các Đơn Hàng",
    "message.views.liveInventory.onWay.transferOnWay": "Chuyển OnWay",
    "message.login.user_profile": "Hướng dẫn sử dụng Hồ Sơ",
    "message.aegOutboundOrderDetail.title.merchantName": "Thương gia Tên",
    "message.views.scItemView.shelfLifeManagement": "Thời hạn sử dụng Quản Lý",
    "message.views.scItemView.mainShop": "MainShop",
    "message.taskCenterView.table.taskStatus": "Nhiệm vụ Tình Trạng",
    "message.table.fulfillment.buyerName": "Người mua Tên",
    "message.views.dashboardScore.dashboardName.proportion_of_shop_product_sold": "Tỷ lệ Của Sản Phẩm Cửa Hàng Bán",
    "message.inboundView.table.expectedTime": "Thời Gian dự kiến",
    "message.views.workbench.mom": "MẸ",
    "message.CreateTransferOrder.senderName": "Tên người gửi Tên",
    "message.table.fulfillment.sellerName": "Người Bán Tên",
    "message.views.scItemView.length": "Chiều dài",
    "message.inboundView.table.operate": "Hoạt động",
    "message.CreateTransferOrder.receiverCountry": "Thu Nước",
    "message.views.liveInventory.code": "Mã",
    "message.login.switch_to_th_th": "เปลี่ยนเป็นภาษาไทย",
    "message.lzdInboundCreateView.tableColumn.inboundType": "Gửi đến Loại",
    "message.views.dashboardScore.table.comment": "Bình Luận",
    "message.table.fulfillment.unitPrice": "Đơn vị Giá",
    "message.lzdOutboundViewDetail.title.SKU": "MÃ HÀNG",
    "message.outboundView.table.orderQuantity": "Số lượng",
    "message.views.publishTemplateView.gmtCreate": "Tạo ra Thời Gian",
    "message.taskCenterView.table.taskName": "Nhiệm vụ Tên",
    "message.lzdInboundCreateView.tableColumn.warehouse": "Kho",
    "message.form.fulfillment.tradeOrderId": "Thương mại ID Đặt Hàng",
    "message.views.inventoryLedger.changeQuantity": "Thay đổi Số Lượng",
    "message.menu.gfc.title": "Nhập GFC",
    "message.views.productView.category": "Category",
    "message.views.scItemView.operation": "Hoạt động",
    "message.views.workbench.shopGmvProportion": "Tỷ lệ Của GMV",
    "message.drawer.fulfillment.deliveryFailed": "Giao hàng Thất Bại",
    "message.outboundView.table.detail": "Chi tiết",
    "message.transform.startCheck": "Bắt đầu Hàng Tồn Kho Ràng Buộc Kiểm Tra",
    "message.inboundView.button.importBtn": "Nhập khẩu",
    "message.card.fulfillment.shippingServiceCode": "DỊCH VỤ VẬN chuyển Mã",
    "message.views.productPublishView.submit": "Gửi",
    "message.views.publishTemplateView.templateName": "TemplateName",
    "message.transform.bindSuccess": "Hàng tồn kho Ràng Buộc Thành Công",
    "message.transform.shopList": "Ràng buộc Cửa Hàng Danh Sách",
    "message.views.workbench.orderQuantityRank": "Số Lượng đặt hàng Xếp Hạng",
    "message.views.workbench.shopOrderQuantityData": "Tỷ lệ Của số lượng Đặt Hàng",
    "message.transform.bindFailed": "Hàng tồn kho Ràng Buộc Thất Bại",
    "message.views.workbench.cargo": "Vận chuyển hàng hóa",
    "message.views.productView.showRelation": "Hiển thị Mối Quan Hệ",
    "message.views.publishTemplateView.merchant": "Thương gia",
    "message.menu.fulfillmentOrderDetail": "Thực hiện Chi Tiết Đặt Hàng",
    "message.outboundView.table.merchantName": "Thương gia Tên",
    "message.views.scItemView.weight": "Trọng lượng",
    "message.inboundView.table.expiredTime": "Hết hạn Thời Gian",
    "message.views.inventoryAging.121-150day": "121-150 ngày",
    "message.views.workbench.dashboardDescription.channelProductSold": "Thanh Biểu đồ của sản phẩm được bán ra từ các kênh khác nhau trong các cuối cùng tuần",
    "message.menu.ownerTransfer.title": "OwnerTransfer",
    "message.aegOutboundOrderDetail.consignColumn.gmtCreateStr": "Tạo ra Thời Gian",
    "message.menu.feedback.feedbackName": "Thông tin phản hồi",
    "message.views.dashboardScore.dashboardName.monthly_product_sold_and_item_ranking": "Hàng tháng Sản Phẩm Được Bán Và Mục Xếp Hạng",
    "message.views.productView.platformTitle": "Tiêu đề",
    "message.button.helpCenter": "Trung Tâm trợ giúp",
    "message.lzdInboundCreateView.addSkuView.fulfilmentSku": "Fulfilment Mã Hàng",
    "message.lzdInboundDetail.title.ioType": "IO Loại",
    "message.lzdInboundCreateView.tableColumn.estimatedTime": "Thời Gian dự kiến",
    "message.views.stockAllocation.allLessThan100": "Tất cả các tỷ lệ không được phép ít hơn 100, xin vui lòng điều chỉnh.",
    "message.views.scItemView.fileExport": "Xuất khẩu",
    "message.message.fulfillment.deliveryConfirm": "Giao hàng xác nhận!",
    "message.aegInboundDetail.title.remart": "Remart",
    "message.views.activityInventory.fulfillmentSkuName": "Thực hiện Mã Hàng Tên",
    "message.views.workbench.fulfillmentOrderItemId": "Thực hiện Mục Đặt Hàng ID",
    "message.views.liveInventory.occupy": "Khóa",
    "message.outboundView.table.orderStatus": "Tình Trạng đặt hàng",
    "message.aegInboundDetail.purchaseItemColumn.quantityDec": "Mua Số Lượng",
    "message.aegInboundDetail.goodsTable.defectiveQtyDec": "Bị lỗi Số Lượng.",
    "message.views.inventoryLedger.operateTime": "Thời Gian hoạt động",
    "message.lzdInboundDetail.title.warehouseName": "Kho",
    "message.lzdInboundCreateView.addSkuView.searchBtn": "Tìm kiếm",
    "message.aegInboundDetail.logisticColumns.fulfillStatus": "Tình trạng",
    "message.transform.auth": "Ủy Quyền",
    "message.views.inventoryLedger.orderTypeMap.INVENTORY_STATUS_ADJUST_IN": "Tình trạng hàng tồn kho điều chỉnh",
    "message.lzdInboundCreateView.addSkuView.shelfLife": "Thời hạn sử dụng",
    "message.views.workbench.thisMonth": "Tháng này"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alife_mcms_crossborder-merchant-web_front_end@0.0.20@@alife/mcms_crossborder-merchant-web_front_end/vi-vn.js
// module id = ESIh
// module chunks = 16